import React from 'react';
import { RadioGroup, RadioButton } from 'react-toolbox/lib/radio';
import Styles from './RadioButtonGroup.css';

const RadioButtonGroup = ({
  value,
  radioButtonData,
  radioButtonName,
  radioStyle,
  handleRadioChange }) => (
    <RadioGroup
      name={radioButtonName}
      onChange={handleRadioChange}
      value={value}
      theme={radioStyle || Styles.radioGroup}
      className={Styles.radioGroup}
    >
      {
        radioButtonData.map((subItems, index) =>
          <RadioButton
            label={subItems.label}
            value={subItems.value}
            theme={Styles}
            key={`RadioButton, ${index}!`}
          />
        )
      }
    </RadioGroup>
);
RadioButtonGroup.propTypes = {
  value: React.PropTypes.string,
  radioButtonData: React.PropTypes.arrayOf(React.PropTypes.shape({})),
  radioButtonName: React.PropTypes.string,
  handleRadioChange: React.PropTypes.func,
  radioStyle: React.PropTypes.objectOf(React.PropTypes.shape({}))
};
export default RadioButtonGroup;



// WEBPACK FOOTER //
// ./src/components/RadioButtonGroup/RadioButtonGroup.js